<div *ngIf="isLoading" 
     [class]="getOverlayClasses()" 
     [attr.data-height-category]="heightCategory"
     style="top: 0; left: 0; right: 0; background: rgba(255,255,255,0.85);"
     [style.height]="height"
     [style.z-index]="zIndex">
  <div [class]="containerClass">
    <div class="mb-3">
      <i [class]="icon + ' ' + iconColor"></i>
    </div>
    <div *ngIf="showDots" class="loading-dots mb-3">
      <div [class]="'dot ' + dotsColor"></div>
      <div [class]="'dot ' + dotsColor"></div>
      <div [class]="'dot ' + dotsColor"></div>
    </div>
    <h5 class="text-dark font-weight-bold mb-2">
      {{message}}
    </h5>
    <p class="text-muted mb-0">{{subMessage}}</p>
  </div>
</div>
